import { call, put, takeLatest } from 'redux-saga/effects';
import {
  selectCityFailure,
  selectCitySuccess,
  selectCountryAirportFailure,
  selectCountryAirportSuccess,
  selectCountryFailure,
  selectCountrySuccess,
  selectStateAirportFailure,
  selectStateAirportSuccess,
  selectStateFailure,
  selectStateSuccess,
} from './selectorAction';
import getCountryApi, {
  getCityApi,
  getCountryAirportApi,
  getStateAirportApi,
  getStateApi,
} from './selectorEffect';
import {
  SELECT_CITY_REQUEST,
  SELECT_COUNTRY_AIRPORT_REQUEST,
  SELECT_COUNTRY_REQUEST,
  SELECT_STATE_AIRPORT_REQUEST,
  SELECT_STATE_AIRPORT_SUCCESS,
  SELECT_STATE_REQUEST,
  SELECT_STATE_SUCCESS,
} from './selectorType';

function* getCountrySaga() {
  try {
    const response = yield call(getCountryApi);

    yield put(selectCountrySuccess(response)); //here reponse come like{message:"some"}so use reponse.message this will set action from action go to reducer
  } catch (error) {
    yield put(selectCountryFailure(error.message));
  }
}
function* getStateSaga(id) {
  try {
    const response = yield call(getStateApi, id);

    yield put(selectStateSuccess(response));
  } catch (error) {
    yield put(selectStateFailure(error.message));
  }
}
function* getCitySaga(id) {
  try {
    const response = yield call(getCityApi, id);

    yield put(selectCitySuccess(response));
  } catch (error) {
    yield put(selectCityFailure(error.message));
  }
}
//
function* getCountryAirportSaga() {
  try {
    const response = yield call(getCountryAirportApi);

    yield put(selectCountryAirportSuccess(response)); //here reponse come like{message:"some"}so use reponse.message this will set action from action go to reducer
  } catch (error) {
    yield put(selectCountryAirportFailure(error.message));
  }
}
function* getStateAirportSaga(id) {
  try {
    const response = yield call(getStateAirportApi, id);

    yield put(selectStateAirportSuccess(response));
  } catch (error) {
    yield put(selectStateAirportFailure(error.message));
  }
}
export default function* selectorSaga() {
  yield takeLatest(SELECT_COUNTRY_REQUEST, getCountrySaga);
  yield takeLatest(SELECT_STATE_REQUEST, getStateSaga);
  yield takeLatest(SELECT_CITY_REQUEST, getCitySaga);
  yield takeLatest(SELECT_COUNTRY_AIRPORT_REQUEST, getCountryAirportSaga);
  yield takeLatest(SELECT_STATE_AIRPORT_REQUEST, getStateAirportSaga);
}
